import { Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import CheckListModal from "./CheckListForm/CheckListModal";
import { CheckListType } from "./CheckLists.types";
import { useChecklistsContext } from "./CheckListsContext";

type Props = {
  title: string;
  type: CheckListType;
};

const AddCheckListButton = ({ title, type }: Props) => {
  const [opened, { open, close }] = useDisclosure();
  const { checklists } = useChecklistsContext();
  const handleClick = (event: any) => {
    event.preventDefault();
    open();
  };
  return (
    <>
      <Button type="button" variant="outline" onClick={handleClick}>
        {title}
      </Button>
      <CheckListModal
        opened={opened}
        onClose={close}
        buttonType={type}
        defaultValues={{ sort: checklists.length + 1 } as any}
      />
    </>
  );
};

export default AddCheckListButton;
